module.exports = __webpack_public_path__ + "static/media/18ECA37.b15203ec.jpg";